import * as React from "react";
import PropTypes from "prop-types";
import { Input } from "@fluentui/react-components";
import { FluentField } from "../../../../components/FluentUI/Fluent-Field";
import './sub-department.scss';
import objectlabelssvg from "../../../../assets/Illustrations/object-labels.svg";

export const ObjectLabels = ({ subDepartment, setSubDepartment, errors, setErrors }) => {

    const handleInputChange = (fieldPath, value) => {
        const keys = fieldPath.split('.');
        setSubDepartment({
            ...subDepartment,
            ObjectLabels: {
                ...subDepartment.ObjectLabels,
                [keys[keys.length - 1]]: value
            }
        });

        // Clear error on input change if field becomes valid
        if (value && value.trim()) {
            setErrors({ ...errors, [fieldPath]: false });
        }
    };

    const getErrorMessage = (fieldPath) => {
        return errors?.[fieldPath] ? "This field is required" : "";
    };

    return (
        <div className={`sub-department-object-labels`}>
            <div className="d-flex section-description-container">
                <div className="section-description">
                    <p>Customize the terminology for Projects, Tasks, and Forms to align with your team’s internal language by defining singular, plural, and possessive forms.</p>
                    <p>These labels are applied consistently across all relevant views and workflows for users in this Sub-Department.</p>
                </div>
                <img src={objectlabelssvg} alt="Description of image" />
            </div>

            <div className="object-label-container">
                {/* Projects Section */}
                <div className="label-section">
                    <div className="section-container">
                        <div className="section-header-text">Projects</div>
                        <div className="section-row">
                            <FluentField label="Singular" required size="medium" validationMessage={getErrorMessage('ObjectLabels.ProjectSingular')}>
                                <Input
                                    type="text"
                                    placeholder="Project"
                                    value={subDepartment?.ObjectLabels?.ProjectSingular || ""}
                                    onChange={(e) => handleInputChange('ObjectLabels.ProjectSingular', e.target.value)}
                                    className="fluent-input"
                                />
                            </FluentField>

                            <FluentField label="Plural" required size="medium" validationMessage={getErrorMessage('ObjectLabels.ProjectPlural')}>
                                <Input
                                    type="text"
                                    placeholder="Projects"
                                    value={subDepartment?.ObjectLabels?.ProjectPlural || ""}
                                    onChange={(e) => handleInputChange('ObjectLabels.ProjectPlural', e.target.value)}
                                    className="fluent-input"
                                />
                            </FluentField>
                        </div>
                        <div className="section-row">
                            <FluentField label="Singular Possessive" required size="medium" validationMessage={getErrorMessage('ObjectLabels.ProjectSingularPossessive')}>
                                <Input
                                    type="text"
                                    placeholder="Project's"
                                    value={subDepartment?.ObjectLabels?.ProjectSingularPossessive || ""}
                                    onChange={(e) => handleInputChange('ObjectLabels.ProjectSingularPossessive', e.target.value)}
                                    className="fluent-input"
                                />
                            </FluentField>

                            <FluentField label="Plural Possessive" required size="medium" validationMessage={getErrorMessage('ObjectLabels.ProjectPluralPossessive')}>
                                <Input
                                    type="text"
                                    placeholder="Projects'"
                                    value={subDepartment?.ObjectLabels?.ProjectPluralPossessive || ""}
                                    onChange={(e) => handleInputChange('ObjectLabels.ProjectPluralPossessive', e.target.value)}
                                    className="fluent-input"
                                />
                            </FluentField>
                        </div>
                    </div>
                </div>
                {/* Tasks Section */}
                <div className="label-section">
                    <hr className="divider" />
                    <div className="section-container">
                        <div className="section-header-text">Tasks</div>
                        <div className="section-row">
                            <FluentField label="Singular" required size="medium" validationMessage={getErrorMessage('ObjectLabels.TaskSingular')}>
                                <Input
                                    type="text"
                                    placeholder="Task"
                                    value={subDepartment?.ObjectLabels?.TaskSingular || ""}
                                    onChange={(e) => handleInputChange('ObjectLabels.TaskSingular', e.target.value)}
                                    className="fluent-input"
                                />
                            </FluentField>

                            <FluentField label="Plural" required size="medium" validationMessage={getErrorMessage('ObjectLabels.TaskPlural')}>
                                <Input
                                    type="text"
                                    placeholder="Tasks"
                                    value={subDepartment?.ObjectLabels?.TaskPlural || ""}
                                    onChange={(e) => handleInputChange('ObjectLabels.TaskPlural', e.target.value)}
                                    className="fluent-input"
                                />
                            </FluentField>
                        </div>
                        <div className="section-row">
                            <FluentField label="Singular Possessive" required size="medium" validationMessage={getErrorMessage('ObjectLabels.TaskSingularPossessive')}>
                                <Input
                                    type="text"
                                    placeholder="Task's"
                                    value={subDepartment?.ObjectLabels?.TaskSingularPossessive || ""}
                                    onChange={(e) => handleInputChange('ObjectLabels.TaskSingularPossessive', e.target.value)}
                                    className="fluent-input"
                                />
                            </FluentField>

                            <FluentField label="Plural Possessive" required size="medium" validationMessage={getErrorMessage('ObjectLabels.TaskPluralPossessive')}>
                                <Input
                                    type="text"
                                    placeholder="Tasks'"
                                    value={subDepartment?.ObjectLabels?.TaskPluralPossessive || ""}
                                    onChange={(e) => handleInputChange('ObjectLabels.TaskPluralPossessive', e.target.value)}
                                    className="fluent-input"
                                />
                            </FluentField>
                        </div>
                    </div>
                </div>
                {/* Forms Section */}
                <div className="label-section">
                    <hr className="divider" />
                    <div className="section-container">

                        <div className="section-header-text">Forms</div>
                        <div className="section-row">
                            <FluentField label="Singular" required size="medium" validationMessage={getErrorMessage('ObjectLabels.FormSingular')}>
                                <Input
                                    type="text"
                                    placeholder="Form"
                                    value={subDepartment?.ObjectLabels?.FormSingular || ""}
                                    onChange={(e) => handleInputChange('ObjectLabels.FormSingular', e.target.value)}
                                    className="fluent-input"
                                />
                            </FluentField>

                            <FluentField label="Plural" required size="medium" validationMessage={getErrorMessage('ObjectLabels.FormPlural')}>
                                <Input
                                    type="text"
                                    placeholder="Forms"
                                    value={subDepartment?.ObjectLabels?.FormPlural || ""}
                                    onChange={(e) => handleInputChange('ObjectLabels.FormPlural', e.target.value)}
                                    className="fluent-input"
                                />
                            </FluentField>
                        </div>
                        <div className="section-row">
                            <FluentField label="Singular Possessive" required size="medium" validationMessage={getErrorMessage('ObjectLabels.FormSingularPossessive')}>
                                <Input
                                    type="text"
                                    placeholder="Form's"
                                    value={subDepartment?.ObjectLabels?.FormSingularPossessive || ""}
                                    onChange={(e) => handleInputChange('ObjectLabels.FormSingularPossessive', e.target.value)}
                                    className="fluent-input"
                                />
                            </FluentField>

                            <FluentField label="Plural Possessive" required size="medium" validationMessage={getErrorMessage('ObjectLabels.FormPluralPossessive')}>
                                <Input
                                    type="text"
                                    placeholder="Forms'"
                                    value={subDepartment?.ObjectLabels?.FormPluralPossessive || ""}
                                    onChange={(e) => handleInputChange('ObjectLabels.FormPluralPossessive', e.target.value)}
                                    className="fluent-input"
                                />
                            </FluentField>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ObjectLabels.propTypes = {
    subDepartment: PropTypes.shape({
        ObjectLabels: PropTypes.shape({
            ProjectSingular: PropTypes.string,
            ProjectPlural: PropTypes.string,
            ProjectSingularPossessive: PropTypes.string,
            ProjectPluralPossessive: PropTypes.string,
            TaskSingular: PropTypes.string,
            TaskPlural: PropTypes.string,
            TaskSingularPossessive: PropTypes.string,
            TaskPluralPossessive: PropTypes.string,
            FormSingular: PropTypes.string,
            FormPlural: PropTypes.string,
            FormSingularPossessive: PropTypes.string,
            FormPluralPossessive: PropTypes.string,
        }),
    }).isRequired,
    setSubDepartment: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    setErrors: PropTypes.func.isRequired,
};